export default __webpack_public_path__ + "static/media/stakelinkwhite.42a6e002.png";